import router from '@/router'
import store from '@/store'
import LocalStorage from '@/services/localStorage'

const IDLE_TIMEOUT_MS = 30 * 60 * 1000 // 10 minutes
let idleTimer: number | null = null

function isAuthenticated(): boolean {
  const token = LocalStorage.get('token')
  const authFlag = LocalStorage.get('authenticate')
  return !!token && authFlag !== 'false'
}

async function doLogout() {
  try {
    await store.dispatch('LOGOUT')
  } finally {
    router.push({ name: 'Login' })
  }
}

function resetTimer() {
  if (!isAuthenticated()) {
    if (idleTimer) window.clearTimeout(idleTimer)
    idleTimer = null
    return
  }

  if (idleTimer) window.clearTimeout(idleTimer)
  idleTimer = window.setTimeout(doLogout, IDLE_TIMEOUT_MS)
}

export function initIdleLogout() {
  const events = [
    'mousemove',
    'mousedown',
    'keydown',
    'wheel',
    'scroll',
    'touchstart',
    'touchmove',
    'focus',
    'visibilitychange',
  ]

  events.forEach((evt) => {
    window.addEventListener(evt, resetTimer, { passive: true })
  })

  router.afterEach(() => resetTimer())


  window.addEventListener('storage', (e) => {
    if (e.key === 'authenticate' && e.newValue === 'false') {
      doLogout()
    }
  })

  resetTimer()
}